import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('journey_builder_template_analytics_fe');
	},
};
